import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function BtpbDemo() {
    const navigate = useNavigate();
    const frame = useRef(null);
    useEffect(() => {
        function receive(e) {
            if (e.origin !== window.location.origin || e.source !== frame.current?.contentWindow) return;
            if (e.data?.type === 'btpb:exit') navigate('/casino/slots');
        }
        window.addEventListener('message', receive);
        return () => window.removeEventListener('message', receive);
    }, [navigate]);
    return (
        <iframe ref={frame} data-testid="btpb-demo-frame" src="/games/btpb/index.html" title="Break the Piggy Bank" allow="autoplay; fullscreen" allowFullScreen
            style={{ position: 'fixed', inset: 0, width: '100%', height: '100dvh', border: 0, background: '#04070c', zIndex: 60 }} />
    );
}

export default function BtpbRoute() {
    return <BtpbDemo />;
}
